/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class FullPageModal extends React.Component {
    render() {
        let closeButton = null,
            headerClass = 'dlvr-modal-head';

        if (this.props.showClose === undefined || this.props.showClose === true) {
            closeButton = (
                <div className="dlvr-modal-close" onClick={this.props.closeAction} role="button" aria-label="close">
                    <i className="fa fa-remove"></i>
                </div>
            );
        }

        if (this.props.version !== '') {
            headerClass = `dlvr-modal-head ${this.props.version}`;
        }

        return (
            <div className="dlvr-modal full" role="dialog" aria-hidden="false" aria-modal="true">
                <div className={headerClass}>
                    {closeButton}
                    <div className="modal-title">{this.props.title}</div>
                </div>
                <div className="dlvr-modal-content full">
                    {this.props.content}
                </div>
            </div>
        );
    }

};

FullPageModal.propTypes = {
    title: PropTypes.string,
    closeAction: PropTypes.func,
    content: PropTypes.element,
    version: PropTypes.string
};

FullPageModal.defaultProps = {
    title: '',
    closeAction: () => {},
    content: null,
    version: ''
};

export default FullPageModal;
